import { configureStore } from '@reduxjs/toolkit';
import dataSlice from './dataSlice';
import walletSlice from "./walletSlice"; 
import soundSlice from "./soundSlice"
const store = configureStore({
    reducer: {
      data: dataSlice,
      userwallet: walletSlice,
      usersound: soundSlice
    },
  });

export default store;